import { formatDate, parseDate } from 'react-day-picker/moment';
import _ from 'lodash';
import { store } from 'react-notifications-component';
import moment from 'moment';

export const MONTHS_STRINGS = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Aout',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

export const WEEKDAYS_LONG = [
  'Dimanche',
  'Lundi',
  'Mardi',
  'Mercredi',
  'Jeudi',
  'Vendredi',
  'Samedi',
];

export const WEEKDAYS_SHORT = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];

export const arrayToObject = (arr, key = 'appId') => {
  const obj = {};
  arr.forEach(element => {
    obj[element[key]] = element;
  });
  return obj;
};

export function formatDateYYYYMMDD(date) {
  return formatDate(new Date(date), 'YYYY-MM-DD');
}

export function formatDateDDMMYYYY(date) {
  return formatDate(new Date(date), 'DD-MM-YYYY');
}

export function getDateFromYYYYMMDD(str) {
  return parseDate(str, 'YYYY-MM-DD');
}

export function extractNameFromKey(key) {
  const sps = String(key).split('/');
  if (sps[sps.length - 1] === '') {
    return sps[sps.length - 2];
  }
  return sps[sps.length - 1];
}

export function getDDMSYYYY(str) {
  const date = new Date(str);
  return `${date.getDate()} ${MONTHS_STRINGS[
    date.getMonth()
  ]} ${date.getFullYear()}`;
}

export function includesSearchWord(title, searchWord) {
  if (searchWord === '') {
    return true;
  }
  return (
    String(title).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(String(searchWord).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()) >= 0
  );
}
export function groupBy(items, key) {
  return items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [
        ...(result[item[key]] || []),
        item,
      ],
    }),
    {},
  );
}
export function mapFiltersFromTableData(arrays, keys) {
  let result = {}
  for (let i = 0; i < keys.length; i++) {
    const values = arrays.map(item => _.get(item, keys[i])).filter(item => !!item)
    result[keys[i]] = values.filter(function (item, pos) {
      return values.indexOf(item) == pos;
    })
  }
  return result
}
export function parseURLQuery(queryString) {
  let query = {};
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}
export function removeDuplicateFromArray(a, key) {
  return a.filter((value, index, self) =>
    index === self.findIndex((t) => (
      key ? t[key] == value[key] : t == value
    ))
  )
}
export function getSiretsFromProfile(profile) {
  const establishments = Array.isArray(profile?.establishments) ? profile.establishments : [];
  const clientSirets = [...establishments];
  if (profile?.siret) {
    clientSirets.push({ name: profile.company, siret: profile.siret, email: profile.clientEmail || profile.email });
  }

  // Restrict available entities to selected companies when permission.sirets exists.
  const effectivePermission = profile?.permission || profile?.clientPermission || {};
  const selectedSirets = Array.isArray(effectivePermission?.sirets) ? effectivePermission.sirets : [];
  if (selectedSirets.length > 0) {
    const selectedSet = new Set(selectedSirets.map(el => String(el)));
    const filtered = clientSirets.filter(item => selectedSet.has(String(item.siret)));
    // Fallback: if backend stores a different identifier shape, do not return empty dropdown.
    return filtered.length > 0 ? filtered : clientSirets;
  }
  return clientSirets;
}

export function fixedPriceFormat(str) {
  const num = Number(str);
  return isNaN(num) ? "" : String(num);
}


export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export const getCountFromActifsAssocies = (value) => {
  let count = 0;
  (value || []).map(el => {
    (el.actifsAssocies || []).map(obs => {
      count = count + (obs.resultatsObservations || []).filter(el => el.Observation).length;
    })
  })
  return count;
}

export const getVisibilityPermission = (profile) => {
  let permission = {};
  switch (profile.role) {
    case "admin":
      return ["inspection", "formation"]
    case "client":
      permission = profile.permission;
      break;
    default:
      // For end-users, prefer explicit user permission; fallback to client defaults.
      permission = profile.permission || profile.clientPermission;
  }
  let visibility = [];
  if (!permission?.homepage?.hasOwnProperty("enable")) {
    if (profile.compteSEL) {
      visibility.push("inspection");
    }
    if (profile.siret) {
      visibility.push("formation");
    }
  } else {
    if (permission?.inspection?.enable) visibility.push("inspection");
    if (permission?.formation?.enable) visibility.push("formation");
  }
  return visibility
}

export const showMessage = (payload) => {
  store.addNotification({
    message: "",
    type: 'success',
    container: 'top-right',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: 5000,
      onScreen: true,
    },
    ...payload,
  });
}

export const getPlainTextFromHtml = (s) => {
  const span = document.createElement('span');
  span.innerHTML = s;
  return span.textContent || span.innerText;
};

/**
 * Encode GED ID with special characters for URL complexity
 * @param {string} gedId - The GED document ID
 * @returns {string} Encoded GED ID with special characters
 */
export const encodeGedId = (gedId) => {
  if (!gedId) return '';
  // Base64 encode and add special characters for complexity
  const base64 = btoa(gedId);
  // Insert special characters at specific positions
  const chars = base64.split('');
  const specialChars = ['@', '#', '$', '%', '&', '*'];
  let encoded = '';
  for (let i = 0; i < chars.length; i++) {
    encoded += chars[i];
    // Add special character every 4 characters (positions 4, 8, 12, etc.)
    if (i > 0 && (i + 1) % 4 === 0 && i < chars.length - 1) {
      encoded += specialChars[i % specialChars.length];
    }
  }
  // Don't encode here - let the URL builder handle encoding
  // This prevents double encoding issues
  return encoded;
};

/**
 * Decode GED ID from encoded format
 * @param {string} encodedGedId - The encoded GED document ID
 * @returns {string} Decoded GED ID
 */
export const decodeGedId = (encodedGedId) => {
  if (!encodedGedId) return '';
  try {
    const decoded = decodeURIComponent(encodedGedId);
    // Remove special characters
    const cleaned = decoded.replace(/[@#$%&*]/g, '');
    // Base64 decode
    return atob(cleaned);
  } catch (error) {
    console.error('Error decoding GED ID:', error);
    return '';
  }
};

export const getDateFormat = (date, fm) => {
  if (date) {
    return moment(date).format(fm || "DD/MM/YYYY")
  } return ""
}

/**
 * Decode JWT token payload
 * @param {string} token - The JWT token
 * @returns {object|null} Decoded token payload or null if invalid
 */
export const decodeTokenPayload = (token) => {
  if (!token) return null;
  try {
    // JWT token format: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    // Decode the payload (base64)
    const payload = JSON.parse(atob(parts[1]));
    return payload;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

/**
 * Extract user ID from JWT token
 * @param {string} token - The JWT token
 * @returns {string} User ID from token or empty string
 */
export const getUserIdFromToken = (token) => {
  const payload = decodeTokenPayload(token);
  if (!payload) return '';
  // The user ID is in the 'sub' field
  return payload.sub || payload.id || '';
};

/**
 * Extract role from JWT token
 * @param {string} token - The JWT token
 * @returns {string} Role from token or empty string
 */
export const getRoleFromToken = (token) => {
  const payload = decodeTokenPayload(token);
  if (!payload) return '';
  // The role is in the 'role' field
  return payload.role || '';
};